<template>
  <div style="width: 100%">
    <table class="ui striped selectable table">
      <thead>
        <tr>
          <th>#</th>
          <th>Content</th>
          <th>Image</th>
          <th>Created at</th>
          <th>Updated at</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!news || news.length == 0">
          <td></td>
          <td colspan="4">No news found</td>
        </tr>
        <news-table-row v-for="newsItem in news" v-bind:newsItem="newsItem" v-bind:key="newsItem.id"
          v-bind:actions="actions" v-on:action="rowAction" />
      </tbody>
    </table>
  </div>
</template>

<script>
import NewsTableRow from '@/components/website/news/NewsTableRow';

export default {
  name: 'NewsTable',
  components: { NewsTableRow },
  props: ['news', 'actions'],
  methods: {
    rowAction(action) {
      this.$emit('rowAction', action);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/news/NewsTable.vue